import Music from "source/app/services/Sound/Music/Music";
import SoundManager from "source/app/services/Sound/SoundManager";
import URLs from "source/app/services/External/URLs";
import Ambience from "../Ambience/Ambience";
import { ChangeRadioStationAsync } from "./ChangeRadioStations";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { GetCachedRadioStationsAsync } from "./CachedRadioStations";
import { IToolsState } from "source/app/presentation/Header/Tools/ToolsState";
import { MathUtils } from "../../Math/MathUtils";
import { State } from "source/app/services/UI/State/State";
import { IRadioStation } from "motw_core/Entity/IRadioStation";
import * as moment from "moment";
import HowlAudioProvider from "source/app/services/Sound/AudioProvider/HowlAudioProvider";

export const GAMEStation: IRadioStation = {
    id: 0,
    url: "",
    volume: 1.0,
    lastmodifiedtime: moment().toISOString(),
};

export const StartRadioAsync = async (radioStation?: IRadioStation) => {
    if (!radioStation) {
        const randomStation = await GetRandomRadioStationAsync();
        radioStation = randomStation;
    }

    var radioName = radioStation.url
        .replace(`${URLs.mediaServer}somafm/`, "")
        .toUpperCase();

    var radioHowl = SoundManager.PlayStream({
        src: radioStation.url,
        volume: radioStation.volume,
    });

    State.ReadClass<IToolsState>(ESharedComponent.Tools).setState({
        radioStationURL: radioStation.url,
        radioName,
        radioHowl,
        radioVolume: radioStation.volume,
    });

    return radioName;
};

export const PreviousRadioStationAsync = async () => {
    const newRadioStation = await ChangeRadioStationAsync(-1);

    if (newRadioStation.url !== GAMEStation.url) {
        SoundManager.ShuffleEnvironment(newRadioStation);
    } else {
        SoundManager.StopAll();
        Music.StartNextSong();
    }
};

export const NextRadioStationAsync = async () => {
    const newRadioStation = await ChangeRadioStationAsync(1);

    if (newRadioStation.url !== GAMEStation.url) {
        SoundManager.ShuffleEnvironment(newRadioStation);
    } else {
        SoundManager.StopAll();
        Ambience.StartNextAmbience();
        Music.StartNextSong();
    }
};

const GetRandomRadioStationAsync = async () => {
    const stations = await GetCachedRadioStationsAsync();

    const inactiveStations = stations.filter(
        (station: IRadioStation) =>
            station.url !==
            State.ReadClass<IToolsState>(ESharedComponent.Tools).state
                .radioStationURL
    );

    var numberOfStations = inactiveStations.length;
    var randomNumberIndex = MathUtils.RandomNumberBetween(
        0,
        numberOfStations - 1
    );
    return inactiveStations[randomNumberIndex];
};
